<span [class]="$type()" [style.fontSize]="$textFontSize() | cssValue">{{ $text() }}</span>
